import React, { useRef, useCallback, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Container } from 'react-bootstrap';

import UnidadesSaudeCadastro from './UnidadeSaudeCadastro';

import Input from '../../components/Input';

import Modal from '../../components/Modal';
import Button from '../../components/Button';

import getValidationErrors from '../../utils/getValidationErrors';

import ListaUnidades from './ListaUnidades';
import { TIPO_USUARIO } from '../../utils/funcoes';
import { useAuth } from '../../hooks/auth';

export interface IFormBusca {
  nome?: string;
  bairro?: string;
  cidade?: string;
}

const UnidadeSaude: React.FC = () => {
  const history = useHistory();
  const { user } = useAuth();

  useEffect(() => {
    if (user.UsuTipo > TIPO_USUARIO.SUPERVISOR) {
      history.push('/sempermissao');
    }
  }, [history, user.UsuTipo]);

  const [dadosForm, setDadosForm] = useState<IFormBusca | undefined>(undefined);

  const formRefBusca = useRef<FormHandles>(null);

  const [showModalCadastro, setShowModalCadastro] = useState(false);

  const handleSubmitBusca = useCallback(async (dados: IFormBusca) => {
    try {
      formRefBusca.current?.setErrors({});
      const schema = Yup.object().shape({
        nome: Yup.string(),
        bairro: Yup.string(),
        cidade: Yup.string(),
      });

      await schema.validate(dados, {
        abortEarly: false,
      });
      setDadosForm(dados);
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        formRefBusca.current?.setErrors(errors);
      }
    }
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleOnChangeVazio = useCallback(() => {}, []);

  // const handleAdd = useCallback(
  //   (dadosMedico: IMedico, medCodigo: number | undefined) => {
  //     if (listaRef.current) {
  //       listaRef.current.addMedico(dadosMedico, medCodigo);
  //     }
  //     setShowModalCadastro(false);
  //   },
  //   [],
  // );

  return (
    <Container fluid className="mt-2">
      {showModalCadastro && (
        <Modal
          show={showModalCadastro}
          titulo="Cadastro de Unidades de Saúde p/Encaminhamentos"
          handleFecharModal={() => setShowModalCadastro(false)}
          large
        >
          <UnidadesSaudeCadastro setShowModal={setShowModalCadastro} />
        </Modal>
      )}

      <div className="bg-white border p-2 mb-2">
        <div className="d-flex justify-content-between mb-2">
          <h2 id="topoBusca">Unidades de Saúde</h2>
          <div>
            <Button
              type="button"
              variant="success"
              onClick={() => {
                setShowModalCadastro(true);
              }}
            >
              Nova Unidade de Saúde
            </Button>
          </div>
        </div>

        <Form ref={formRefBusca} onSubmit={handleSubmitBusca}>
          <div className="row">
            <div className="col-md-4 form-group">
              <Input
                name="nome"
                label="Nome"
                placeholder="NOME"
                maxLength={100}
                minLength={3}
              />
            </div>
            <div className="col-md-3">
              <Input
                name="bairro"
                label="Bairro"
                placeholder="BAIRRO"
                maxLength={100}
                minLength={3}
              />
            </div>
            <div className="col-md-3 form-group">
              <Input
                name="cidade"
                label="Cidade"
                placeholder="Cidade"
                maxLength={100}
                minLength={3}
              />
            </div>
            <div className="col-md-2">
              <div className="input-group-append mt-3">
                <Button type="submit" variant="secondary-outline">
                  BUSCAR
                </Button>
              </div>
            </div>
          </div>
        </Form>
      </div>
      <div className="bg-white border p-2">
        <ListaUnidades dados={dadosForm} />
      </div>
    </Container>
  );
};

export default UnidadeSaude;
